import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsUnblindingEmergencyRequestServices } from "../../../../APIServices/EIWRS/UnblindManagement/eiwrsUnblindingEmergencyRequestServices";

const UpdateStatusStudyUnblindEmergencyRequest = ({
  unblindData,
  getEIWRSUnblindingEmergencyRequestData,
  getEIWRSUnblindingEmergencyRequestStats,
  Show,
  Hide,
  Title,
  status,
  setUnblindId,
}) => {
  const { studyId } = useParams()
  const [revokedComment, setRevokedComment] = useState("");
  const [decisionComment, setDecisionComment] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const updateStatusEIWRSUnblindingEmergencyRequestData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${status} this request!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = unblindData?._id;
        userData.studyId = studyId;
        userData.status = status;
        userData.revokedComment = revokedComment;
        userData.decisionComment = decisionComment;
        userData.mode = StudyMode;
        let data = await eiwrsUnblindingEmergencyRequestServices.updateStatusEIWRSUnblindingEmergencyRequestData(
          userData
        );
        if (data?.statusCode === 200) {
          getEIWRSUnblindingEmergencyRequestData();
          getEIWRSUnblindingEmergencyRequestStats();
          Hide();
          setUnblindId("");
          setRevokedComment("");
          setDecisionComment("");
        }
      }
      setButtonLoader(false);
    });
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {status === "revoked" &&
            <Form.Group className="mb-1">
              <Form.Label className="fw-bold mb-1">
                Revoke Comment <abbr title="Required" className="text-danger"> *</abbr>
              </Form.Label>
              <Form.Control
                onChange={(e) => setRevokedComment(e.target.value)}
                value={revokedComment}
                className="br3"
                placeholder="Enter Revoke Comment"
                as="textarea"
              />
            </Form.Group>
          }
          {status === "approved" &&
            <Form.Group className="mb-1">
              <Form.Label className="fw-bold mb-1">
                Decision Comment <abbr title="Required" className="text-danger"> *</abbr>
              </Form.Label>
              <Form.Control
                onChange={(e) => setDecisionComment(e.target.value)}
                value={decisionComment}
                className="br3"
                placeholder="Enter Decision Comment"
                as="textarea"
              />
            </Form.Group>
          }
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={status === "revkoed" ? !revokedComment : status === "approved" ? !decisionComment : false || buttonLoader}
            className="updateProfile"
            onClick={(e) => updateStatusEIWRSUnblindingEmergencyRequestData(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> {status === "revoked" ? "Revoking" : "Approving"}...
              </div>
            ) : (
              status === "revoked" ? "Revoke Now" : "Approved Now"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateStatusStudyUnblindEmergencyRequest;
